import React, { useEffect } from 'react';

import { EmptyStateKind } from 'src/redux/jira/constants';
import { publishScreenEvent } from 'src/utils/analytics/publish';

import { SCREEN_NAME } from '../../constants';
import { OnboardingDialog } from '../../onboarding';
import SiteIssuesList from '../../site-issues-list/site-issues-list';
import { AssigneesFilter } from '../assignees-filter';
import { ClearFiltersButton } from '../clear-filters-button';
import { IssueCategoryFilter } from '../issue-category-filter';
import { RelevantProjectsFilter } from '../relevant-projects-filter';
import { RelevantSitesFilter } from '../relevant-sites-filter';
import { TextSearchFilter } from '../text-search-filter';

import NoRelevantProjectsEmptyState from './empty-state-no-relevant-projects';
import * as styles from './relevant-issues-content.styled';

type Props = {
  emptyState: EmptyStateKind;
};

export const JiraPageM2 = ({ emptyState }: Props) => {
  const notEmptyState = emptyState === EmptyStateKind.None;

  useEffect(() => {
    publishScreenEvent(SCREEN_NAME, { variation: 'issueList' });
    // This hook is meant to be run only once, hence the empty deps.
  }, []);

  return emptyState === EmptyStateKind.HasNoRelevantProjects ? (
    <NoRelevantProjectsEmptyState />
  ) : (
    <>
      <styles.FiltersContainer>
        {notEmptyState && (
          <styles.TextFilterItem>
            <TextSearchFilter />
          </styles.TextFilterItem>
        )}
        <styles.FilterItem>
          <RelevantSitesFilter />
        </styles.FilterItem>
        {notEmptyState && (
          <>
            <styles.FilterItem isReducedFilterPadding>
              <AssigneesFilter />
            </styles.FilterItem>
            <styles.FilterItem isReducedFilterPadding>
              <RelevantProjectsFilter />
            </styles.FilterItem>
            <styles.FilterItem isReducedFilterPadding>
              <IssueCategoryFilter />
            </styles.FilterItem>
            <styles.FilterItem isReducedFilterPadding>
              <ClearFiltersButton />
            </styles.FilterItem>
          </>
        )}
      </styles.FiltersContainer>
      <SiteIssuesList emptyState={emptyState} />
      <OnboardingDialog />
    </>
  );
};
